export const toContactOption = (contact)=>({
        id: contact.id(),
        name: contact.fullName(),
        companyName: contact.companyName(),
        email: contact.email()
    });
